export default "__VITE_ASSET__BBom_bg5__"